import Vue from 'vue'
import Router from 'vue-router'
import utils from '@/utils';
// import Mine from '../views/MineView/Mine'

const Mine = () => import('views/MineView/Mine')
const Rebate = () => import('views/RebateView/Rebate')
const Rule = () => import('views/RuleView/Rule')


const TouTiaoMine = () => import('views/TouTiaoApp/mine/TouTiaoMine')
const TouTiaoRebate = () => import('views/TouTiaoApp/rebate/TouTiaoRebate')
const CashOut = () => import('views/TouTiaoApp/cashout/CashOut')
const ChangePassword = () => import('views/TouTiaoApp/changepassword/ChangePassword')


const V3Mine = () => import('views/SdkV3/mine/V3Mine')
const V3Rebate = () => import('views/SdkV3/rebate/V3Rebate')

// const originalPush = Router.prototype.push

// Router.prototype.push = function push(location) {  
//   return originalPush.call(this, location).catch(err => err)
// }


Vue.use(Router)

let routes = [
  {
    path:"/index.html",
    redirect: "/rebate"
  },
  {
    path:"/",
    redirect: "/rebate"
  },
  {
    path: "/mine",
    component: Mine
  },
  {
    path: "/rebate",
    component: Rebate
  },
  {
    path: "/rule",
    component: Rule
  }
]


let type = utils.getUrlKey("type")
if ("toutiao" === type) {
  routes = [
    {
      path:"/index.html",
      redirect: "/toutiaomine"
    },
    {
      path:"/",
      redirect: "/toutiaomine"
    },
    // 头条专用页面的 ‘我的’
    {
      path: "/toutiaomine",
      component: TouTiaoMine
    },
    // 头条专用页面的 ‘限时红包’
    {
      path: "/toutiaorebate",
      component: TouTiaoRebate,
      // meta:{keepAlive:true}
    },
    // 兑换
    {
      path: "/cashout",
      component: CashOut,
    },
    // 修改密码
    {
      path: "/changePassword",
      component: ChangePassword,
    },

  ]
}
if ("sdkV3" === type) {
  routes = [
    {
      path:"/index.html",
      redirect: "/v3mine"
    },
    {
      path:"/",
      redirect: "/v3mine"
    },
    // 头条专用页面的 ‘我的’
    {
      path: "/v3mine",
      component: V3Mine
    },
    // 头条专用页面的 ‘限时红包’
    {
      path: "/v3rebate",
      component: V3Rebate,
      // meta:{keepAlive:true}
    },

  ]
}

export default new Router({
  routes,
  // mode: 'history',// 模式，避免地址栏显示多余的#
  linkActiveClass: "router-active" //当前选中的 router-link 的class的值，可以用于在style中设置这个class name,展示不同的选中状态
})



// WEBPACK FOOTER //
// ./src/router/index.js